module.exports = __webpack_public_path__ + "static/light-33b207e1008837107bc2e5647f8bda5a.svg";